import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import { ChangeEvent } from 'react';
import { useSearchInputStyles } from './SearchInput.styles';

type SearchInputProps = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  ariaLabel: string;
  iconPosition?: 'left' | 'right';
  constrained?: boolean;
  className?: string;
};

const SearchInput = ({
  value,
  onChange,
  placeholder = 'Rechercher',
  ariaLabel,
  iconPosition = 'left',
  constrained = false,
  className,
}: SearchInputProps) => {
  const classes = useSearchInputStyles();
  const hasValue = value.length > 0;

  const handleClear = () => {
    onChange({
      target: { value: '' },
    } as ChangeEvent<HTMLInputElement>);
  };

  return (
    <div
      className={clsx(
        classes.searchWrap,
        constrained && classes.searchWrapConstrained,
        className,
      )}>
      {iconPosition === 'left' && <SearchIcon className={classes.searchIconLeft} />}
      <input
        className={clsx(
          iconPosition === 'left' ? classes.searchInputLeft : classes.searchInputRight,
          hasValue && classes.searchInputWithClear,
        )}
        type="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {hasValue ? (
        <button
          type="button"
          className={classes.searchClearButton}
          onClick={handleClear}
          aria-label="Effacer la recherche">
          <CloseIcon className={classes.searchClearIcon} />
        </button>
      ) : (
        iconPosition === 'right' && <SearchIcon className={classes.searchIconRight} />
      )}
    </div>
  );
};

export default SearchInput;
